import React from 'react';
import { useHistory } from 'react-router';

const PageNotFound = () => {
  const history = useHistory();

  return (
    <div className='gx-page-error-container'>
      <div className='gx-page-error-content'>
        <div className='gx-error-code gx-mb-4'>404</div>
        <h2 className='gx-text-center'>Oops, an error has occurred. Page not found!</h2>
        <p className='gx-text-center'>
          <button className='gx-btn gx-btn-primary' type='button' onClick={() => history.push('/')}>
            Go to Home
          </button>
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
